import React from "react";
import "./Contact.css";
import Layout from "../layout/layout";
import ContactForm from "../Components/contactForm";
import { InstagramEmbed } from "react-social-media-embed";

function Contact() {
  return (
    <Layout>
      <div className="contactContainer">
        {/* HERO */}
        <div className="contactSplash">
          <div className="contactSplashInner">
            <h1>Let’s see if Reszko Nation is the right fit.</h1>
            <p>
              Share a few details and we’ll reach out with next steps within 24
              hours.
            </p>
          </div>
        </div>

        {/* BODY */}
        <div className="contactBottomContainer">
          <div className="contactBottom">
            {/* LEFT: FORM */}
            <div className="contactBottomLeft">
              <div className="contactCard">
                <h2 className="contactCardTitle">Request a Call</h2>
                <p className="contactCardSubtitle">
                  Tell us where you’re at — we’ll confirm fit and office
                  alignment.
                </p>
                <ContactForm />
              </div>
            </div>

            {/* RIGHT: INFO + EMBED */}
            <div className="contactBottomRight">
              <div className="contactAside">
                <h3>What happens next</h3>
                <ol className="contactSteps">
                  <li>We review your info (same day).</li>
                  <li>Quick call to confirm fit (10–15 minutes).</li>
                  <li>Interview + office match.</li>
                </ol>

                <div className="contactAsideDivider" />

                <div className="contactTrust">
                  <p>
                    <b>Built for producers:</b> national carrier access,
                    in-person training, and a platform designed to scale.
                  </p>
                </div>

                {/* CULTURE PREVIEW CARD */}
                <div className="culturePreview">
                  <div className="cultureImage" />
                  <div className="cultureContent">
                    <p className="cultureLabel">See the Culture</p>
                    <h4>2026 Won’t Be Different Unless You Become Different</h4>
                    <a
                      href="https://www.instagram.com/p/DTkvt9SCEvX/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cultureButton"
                    >
                      Watch on Instagram
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* OPTIONAL: small reassurance line */}
          <p className="contactFinePrint">
            Prefer email? Reach out anytime — we’ll respond within 48 hours.
          </p>
        </div>
      </div>
    </Layout>
  );
}

export default Contact;
